import styled from 'styled-components';
import { rtl } from '../../../utils/language';
import { mediaQueries } from '../MediaQueries/mediaQueries';

const Container = styled.div`
  border-radius: 8px;
  box-shadow: 0 12px 20px 0 rgba(0, 0, 0, 0.05);
  background-color: var(--white);
  padding: 25px 32px;
  height: 100%;

  ${rtl`
    font-family: Tajawal !important;
    direction: rtl;
  `};

  ${mediaQueries('screen-small', 'max')`
      padding: 25px 20px;
  `};
`;

export default Container;
